import React from 'react';
import MobileAdHeroSection from '../components/MobileAdHeroSection';

const MobileAdPage = () => {
  return (
    <div className="min-h-screen bg-[#0A0A12]">
      <MobileAdHeroSection />
    </div>
  );
};

export default MobileAdPage;
